// NOTE: this file was auto-generated with `libraries/icons/src/_private/transform.ts`
// Any manual edits will be overwritten via `rush build`

import { SVGProps } from 'react';

const Youtube = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 96 96" {...props}>
		<path
			fill="#FFF"
			fillRule="evenodd"
			d="M85.873 28.998C87.565 35.18 87.5 48.065 87.5 48.065s0 12.82-1.627 19.002a9.898 9.898 0 0 1-6.963 6.963C72.728 75.656 48 75.656 48 75.656s-24.663 0-30.91-1.692a9.898 9.898 0 0 1-6.963-6.962C8.5 60.885 8.5 48 8.5 48s0-12.82 1.627-19.002c.91-3.383 3.644-6.117 6.963-7.028C23.272 20.344 48 20.344 48 20.344s24.728 0 30.91 1.692a9.898 9.898 0 0 1 6.963 6.962ZM40.126 59.843 60.689 48 40.126 36.157v23.686Z"
		/>
	</svg>
);
export default Youtube;
